<template>
  <div>
    <table style="width: 100%">
      <tr>
        <td style="width: 20px !important">
          <b-button v-b-toggle.sidebar-1 variant="light" class="summary">
            <b-icon icon="list" />
          </b-button>
        </td>
        <td>
          <center>
            <b>Mots Fléchés : {{ gridName }}</b>
          </center>
        </td>
      </tr>
    </table>

    <b-sidebar id="sidebar-1" title="Mots Fléchés" shadow>
      <div class="px-3 py-2">
        <b-button size="sm" variant="success" @click="doGridList">
          Sélectionner une grille </b-button
        ><br /><br />
        <b-button size="sm" variant="success" @click="doGridSave">
          Sauvegarder la grille
        </b-button>
        <hr />
        <b>Grille :</b><br />
        <b-button
          size="sm"
          :variant="isShowRep ? 'warning' : 'success'"
          @click="doShowRep"
        >
          {{
            isShowRep == false ? "Voir les réponses" : "Cacher les réponses"
          }} </b-button
        ><br /><br />
        <b-button
          size="sm"
          :variant="assisted ? 'warning' : 'success'"
          @click="doAssisted"
        >
          {{
            assisted == false ? "Démarrer l'assistance" : "Stopper l'assistance"
          }}
        </b-button>
        <br /><br />
        <b-button size="sm" variant="warning" @click="doClear">
          Effacer la grille
        </b-button>
        <hr />
        <b>Création :</b><br />
        <b-button size="sm" variant="success" @click="doOpenGridModal">
          Créer une nouvelle grille
        </b-button>
        <br /><br />
        <b-button
          v-if="grid.name != undefined && grid.name != ''"
          size="sm"
          variant="success"
          @click="doRenameGridStart"
        >
          Renommer une grille
        </b-button>
        <br /><br />
        <b-button
          size="sm"
          :variant="creation ? 'warning' : 'success'"
          @click="doCreation"
        >
          {{
            creation == true
              ? "Stopper le mode création"
              : "Passer en mode création"
          }} </b-button
        ><br /><br />
        <span v-if="creation == true">
          <b-button size="sm" variant="success" @click="getGridDatas">
            Affiche les datas</b-button
          ><br /><br />
        </span>
      </div>
    </b-sidebar>

    <CG
      :showrep="isShowRep"
      :assisted="assisted"
      :grille="grid"
      :creation="creation"
    />

    <b-modal
      ref="createGrid"
      hide-footer
      title="Nouvelle grille"
      size="lg"
      :centered="true"
      @hide="cancelCreation"
    >
      <b-container>
        <b-form inline>
          <b-input-group prepend="Grille" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              v-model="grid.name"
              type="text"
              class="mb-2 mr-sm-2 mb-sm-0"
            ></b-form-input
          ></b-input-group>
          <b-input-group prepend="Nb colonnes" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              v-model="grid.cols"
              type="number"
              class="mb-2 mr-sm-2 mb-sm-0"
            ></b-form-input
          ></b-input-group>
          <b-input-group prepend="Nb lignes" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              v-model="grid.rows"
              type="number"
              class="mb-2 mr-sm-2 mb-sm-0"
            ></b-form-input
          ></b-input-group>
          <b-button variant="success" size="sm" @click="doCreateGrid"
            >Créer la grille</b-button
          ><br /><br />
        </b-form>
      </b-container>
    </b-modal>

    <b-modal
      ref="getData"
      hide-footer
      title="Grids datas"
      size="lg"
      :centered="true"
    >
      <b-container>
        <b-form-textarea
          id="textarea-auto-height"
          placeholder="Auto height textarea"
          rows="3"
          max-rows="8"
          v-model="jsonData"
        ></b-form-textarea>
      </b-container>
    </b-modal>

    <b-modal
      ref="selectGrid"
      hide-footer
      title="Sélection de la grille"
      size="lg"
      :centered="true"
    >
      <b-container>
        <b-list-group>
          <b-list-group-item
            v-for="itm of gridList"
            :key="itm.grid"
            @click="select(itm)"
            button
            ><b>{{ itm.grid }}</b>
            {{ itm.used == true ? "(En cours)" : "" }}</b-list-group-item
          >
        </b-list-group>
      </b-container>
    </b-modal>

    <b-modal
      ref="renameGrid"
      hide-footer
      title="Renommer une grille"
      size="lg"
      :centered="true"
    >
      <b-container>
        <b-form inline>
          <b>Ancien nom : </b>{{ grid.name }}
          <b-input-group prepend="Nouveau nom" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              v-model="newGridName"
              type="text"
              class="mb-2 mr-sm-2 mb-sm-0"
            ></b-form-input
          ></b-input-group>
          <b-button variant="success" size="sm" @click="doRenameGrid"
            >Renommer</b-button
          ><br /><br />
        </b-form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import compGrid from "./components/compGrid.vue";

export default {
  name: "App",
  data() {
    return {
      isShowRep: false,
      assisted: false,
      creation: false,
      oldGrid: "",
      gridName: "",
      gridList: [],
      gridEmpty: {
        name: "",
        cols: 0,
        rows: 0,
        value: "",
        cells: {},
        label: {},
        result: {},
      },
      grid: {},
      jsonData: "",
      newGridName: "",
    };
  },
  components: {
    CG: compGrid,
  },
  mounted() {
    //var g = JSON.parse(JSON.stringify(this.gridList.G3));
    // if (this.haveResult(g)) {
    //   var result = confirm("Effacer les valeurs ?");
    //   if (result == true) {
    //     g = this.doClear(g);
    //   }
    // }
    //this.grid = g;

    this.doGridList();
  },
  methods: {
    doRenameGridStart() {
      this.newGridName = this.grid.name;
      this.showModal("renameGrid");
    },

    async doRenameGrid() {
      await this.renameGrid(this.grid.name, this.newGridName);
      this.grid.name = this.newGridName;
      await this.postGrid(this.grid);
      this.hideModal("renameGrid");
    },

    async doGridSave() {
      await this.postGrid(this.grid);
    },

    async doGridList() {
      this.gridList = await this.getGridsList();
      this.showModal("selectGrid");
    },

    async select(itm) {
      this.grid = await this.getGrid(itm.grid);
      if (this.grid.name == undefined) {
        this.grid.name = itm;
      }
      this.gridName = this.grid.name;

      // passage au nv format
      // conversion en cell
      // if (this.grid.cells == undefined) {
      //   this.grid.cells = {};
      //   for (var r = 0; r < this.grid.rows; r++) {
      //     for (var c = 0; c < this.grid.cols; c++) {
      //       var row = this.grid.value[r];
      //       var v = row[c];
      //       var cell = {};
      //       if (v == "*") {
      //         cell.type = "label";
      //         cell.value = this.grid.label["c" + (c + 1) + (r + 1)];
      //         cell.hardBorder = "";
      //       } else {
      //         cell.type = "value";
      //         cell.value = v;
      //         cell.hardBorder = "";
      //       }
      //       this.grid.cells["c" + (c + 1) + (r + 1)] = cell;
      //     }
      //   }
      // }
      // delete this.grid.value;
      // delete this.grid.label;

      // correction hardBorder
      // for (var o of Object.keys(this.grid.cells)) {
      //   if (typeof this.grid.cells[o].hardBorder == "boolean") {
      //     if (this.grid.cells[o].hardBorder == true) {
      //       this.grid.cells[o].hardBorder = "left";
      //     } else {
      //       this.grid.cells[o].hardBorder = "";
      //     }
      //   }
      // }

      this.hideModal("selectGrid");
    },

    haveResult(tmp) {
      var ret = false;
      for (var o of Object.keys(tmp.result)) {
        if (tmp.result[o] != "") {
          ret = true;
        }
      }
      return ret;
    },

    doClear() {
      this.grid = this.doClearResult(this.grid);
    },

    doClearResult(tmp) {
      // generate rep grid
      var res = {};
      for (var c = 1; c <= tmp.cols; c++) {
        for (var r = 1; r <= tmp.rows; r++) {
          res["c" + c + r] = "";
        }
      }
      tmp.result = res;
      return JSON.parse(JSON.stringify(tmp));
    },

    doCreateGrid() {
      this.grid.cols = parseInt(this.grid.cols);
      this.grid.rows = parseInt(this.grid.rows);
      // var t = [];
      // generate value grid
      // for (var o = 0; o < this.grid.rows; o++) {
      //   var r = "".padStart(this.grid.cols, " ");
      //   if (this.grid.value[o] != undefined) {
      //     r = this.grid.value[o];
      //   }
      //   t.push(r);
      // }
      for (var r = 0; r < this.grid.rows; r++) {
        for (var c = 0; c < this.grid.cols; c++) {
          this.grid.cells["c" + (c + 1) + (r + 1)] = {
            type: "value",
            value: "",
            hardBorder: "",
          };
        }
      }

      // t = this.doClearResult(t);
      // this.grid.value = t;

      this.oldGrid = "";
      this.creation = true;
      this.hideModal("createGrid");
    },
    doCreation() {
      this.creation = !this.creation;
    },
    doShowRep() {
      this.isShowRep = !this.isShowRep;
    },
    doAssisted() {
      this.assisted = !this.assisted;
    },

    doOpenGridModal() {
      this.oldGrid = JSON.parse(JSON.stringify(this.grid));
      this.grid = JSON.parse(JSON.stringify(this.gridEmpty));
      this.showModal("createGrid");
    },

    cancelCreation() {
      if (this.oldGrid != "") {
        this.grid = JSON.parse(JSON.stringify(this.oldGrid));
      }
    },

    getGridDatas() {
      // console.log("grid =>");
      // console.log(JSON.stringify(this.grid));
      this.jsonData = JSON.stringify(this.grid);
      this.showModal("getData");
    },

    showModal(m) {
      this.$refs[m].show();
    },

    hideModal(m) {
      this.$refs[m].hide();
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

@media print {
  .summary {
    display: none !important;
  }
}
</style>
